import type { EnvironmentMode } from '@/contexts/EnvironmentContext';

class ApiClient {
  private environment: EnvironmentMode = 'demo';

  setEnvironment(env: EnvironmentMode) {
    this.environment = env;
  }

  getEnvironment(): EnvironmentMode {
    return this.environment;
  }
}

export const apiClient = new ApiClient();
export default apiClient;
